import { Settings } from "@wix/wix-ui-icons-common";
import React, { useContext, useEffect, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { useModalService } from "./../../ricos-modals/index.js";
import { PLUGIN_TOOLBAR_SETTINGS_BUTTON } from "../data-hooks.js";
import { getNodeInSelection } from "../resolvers/get-node-in-selection.js";
import { ToolbarButton as ToolbarButtonComponent } from "../toolbar-button/toolbar-button.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./plugin-toolbar-buttons-ids.js";
const createSettingsButton = ({
  modalId,
  command,
  attributes,
  showLabel,
  dataHook
}) => {
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
    type: "modal",
    attributes: {
      selectedNode: getNodeInSelection,
      active: {
        resolve: (_, { modals }) => Boolean(modals.getModal(modalId))
      },
      ...attributes
    },
    icon: Settings,
    tooltip: "SettingsButton_Tooltip",
    dataHook: dataHook ?? PLUGIN_TOOLBAR_SETTINGS_BUTTON,
    renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(SettingsButton, { toolbarItem, showLabel }),
    command
  };
};
const SettingsButton = ({ toolbarItem, dataHook, showLabel }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [isActive, setIsActive] = useState(toolbarItem.attributes.active);
  const { isMobile, t } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const onClick = toolbarItem.commands.click;
  useEffect(() => {
    modalService.onModalOpened(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
    modalService.onModalClosed(() => {
      setIsActive(Boolean(toolbarItem.attributes.active));
    });
  }, [modalService]);
  return /* @__PURE__ */ React.createElement(
    ToolbarButtonComponent,
    {
      prefix: Settings,
      active: isActive,
      onClick: () => onClick({ isMobile, referenceElement }),
      dataHook,
      tooltip: showLabel ? void 0 : t("SettingsButton_Tooltip"),
      ariaLabel: t("SettingsButton_Tooltip"),
      ref: setReferenceElement,
      label: showLabel ? t("SettingsButton_Tooltip") : void 0,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  createSettingsButton
};
//# sourceMappingURL=create-settings-button.js.map
